import { render } from "./Einarbeitung.vue?vue&type=template&id=aa5e019c"
import script from "./Einarbeitung.vue?vue&type=script&lang=js"
export * from "./Einarbeitung.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__